<template>
  <div class="my-pooq-content-body">
    <portal to="delete-edit-header" v-if="voucherPackageList.length > 0">
      <my-pooq-history-header :change-mode="changeMode" :checked-count="checkedCount" :delete-all="deleteAll"
                              :delete-selected="deleteSelected" :is-delete-mode="isDeleteMode" :total-count="totalCount" view-type="package"/>
    </portal>
    <div class="mypooq-list"
         v-infinite-scroll="loadMore"
         :infinite-scroll-distance="250"
         :infinite-scroll-throttle-delay="200">
      <my-pooq-empty-list v-if="showEmptyList"
                          info-text="패키지 구매 내역이 없어요."></my-pooq-empty-list>
      <div>
      </div>
      <ul class="content-list package-list">
        <li class="item" v-for="(voucherPackage, index) in voucherPackageList" :key="'voucherPackage' + index">
            <span class="list-select" v-if="isDeleteMode" @click.prevent="()=>togglePackageCheck(voucherPackage)">
            <input type="checkbox" :id="'select-btn_' + index" class="select-btn" v-model="voucherPackage.check">
            <label :for="'select-btn_' + index">
                <span class="a11y-hidden">내역 체크박스</span>
                <CheckOn v-if="voucherPackage.check"/>
                <CheckOff v-if="!voucherPackage.check"/>
            </label>
            </span>
            <div class="package-box">
              <div class="package-item-box">
                  <div class="picture-area portrait">
                    <a href="#" @click.prevent="moveToMoviePlayer(voucherPackage)">
                      <WebpImage :image-info="{imageUrl: voucherPackage.image, width: 176, height: 264, alt: voucherPackage.title}" />
                      <age-tag :age-code="voucherPackage.targetage" :content-type="voucherPackage.contenttype.toUpperCase() === 'VOD' ? 'mypooq_vod':'mypooq'"></age-tag>
                    </a>

                  </div>
                <div class="content-box"  @click.prevent="clickToggle(voucherPackage)">
                    <div class="content-info">
                        <span class="product-name">{{voucherPackage.title}}</span>
                        <span class="product-meta">
                          <span>구매일</span>
                          <i class="icon-dotted"></i>
                          <span>{{voucherPackage.startdatetime}}</span>
                        </span>
                        <span class="product-meta">
                          <span>구매금액</span>
                          <i class="icon-dotted"></i>
                          <span>{{voucherPackage.price | amount}}원</span>
                        </span>
                        <span class="product-meta">
                          <span>만료일</span>
                          <i class="icon-dotted"></i>
                          <span>{{voucherPackage.enddatetime}}</span>
                        </span>
                    </div>
                    <button type="button" class="package-toggle">
                      <OpenIcon v-if="!voucherPackage.toggle"/>
                      <CloseIcon v-if="voucherPackage.toggle"/>
                    </button>
                </div>
              </div>
              <voucher-package v-if="voucherPackage.toggle" :package-list-info="voucherPackage" :own="voucherPackage.own"></voucher-package>
            </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { MyPooqService } from '@/common/api/api.service'
import { resizeThumbnail } from '@/common/image.filter'
import { get, throttle } from 'lodash'
import { infiniteScroll } from '@/common/directives'
import VoucherPackage from '@/components/lnb/mypooq/VoucherPackage'
import MyPooqHistoryHeader from '@/components/lnb/mypooq/MyPooqHistoryHeader'
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import { amount } from '@/common/filters'
import CheckOn from '@/assets/svg/common/ic-check-on.svg'
import CheckOff from '@/assets/svg/common/ic-check-off.svg'
import {
  MAX_SELECT_COUNT, MSG_CONFIRM_ALL_DELETE_SALES_EXPIRED,
  MSG_CONFIRM_ALL_DELETE_UNLIMITED_PERIOD, MSG_CONFIRM_SELECT_DELETE_SALES_EXPIRED,
  MSG_CONFIRM_SELECT_DELETE_UNLIMITED_PERIOD,
  SET_EDITOR_VIEW_CLASS
} from '@/common/constant'
import OpenIcon from '@/assets/svg/common/ic_open_w.svg'
import CloseIcon from '@/assets/svg/common/ic-closd-w.svg'
import utils from '@/common/util/utils'
import { EventBus } from '@/components/eventbus/EventBus'
import WebpImage from '@/components/image/WebpImage'
import AgeTag from '@/components/tags/AgeTag'
import { PATH_NAME_PLAYER } from '@/common/router.const'
export default {
  name: 'MyPooqVoucherListPackage',
  directives: {
    infiniteScroll
  },
  filters: {
    amount
  },
  components: {
    MyPooqHistoryHeader,
    VoucherPackage,
    MyPooqEmptyList,
    WebpImage,
    AgeTag,
    CheckOn,
    CheckOff,
    OpenIcon,
    CloseIcon
  },
  data () {
    return {
      offset: 0,
      limit: 10,
      totalCount: 0,
      isDeleteMode: false,
      endOfList: false,
      showEmptyList: false,
      voucherPackageList: [],
      toggle: 'y',
      device: utils.cookies.getDevice()
    }
  },
  computed: {
    checkedCount () {
      return this.voucherPackageList.filter(packageItem => packageItem.check).length
    }
  },
  methods: {
    togglePackageCheck (packageItem) {
      if (this.checkedCount >= MAX_SELECT_COUNT) {
        if (get(packageItem, 'check', false)) {
          packageItem.check = !packageItem.check
        }
        if (this.checkedCount >= MAX_SELECT_COUNT) {
          utils.alert(`최대 ${MAX_SELECT_COUNT}개 까지만 선택할 수 있습니다.`)
        }
      } else {
        packageItem.check = !packageItem.check
      }
    },
    purchaseContentsTypeInfo (selectedContentsList) {
      const isUnlimitedPeriod = selectedContentsList.filter((item) => get(item, 'isunlimitedperiod', 'n') === 'y').length > 0 // 영구소장 콘텐츠
      const isSalesExpired = selectedContentsList.filter((item) => get(item, 'issalesexpired', 'n') === 'y').length > 0 // 판권만료된 콘텐츠
      return { isUnlimitedPeriod, isSalesExpired }
    },
    deleteConfirm (isUnlimitedPeriod, isSalesExpired, deleteType) {
      if ((isUnlimitedPeriod && isSalesExpired) || isSalesExpired) {
        return utils.asyncConfirm(deleteType === 'select'
          ? MSG_CONFIRM_SELECT_DELETE_SALES_EXPIRED
          : MSG_CONFIRM_ALL_DELETE_SALES_EXPIRED)
      } else if (isUnlimitedPeriod > 0) {
        return utils.asyncConfirm(deleteType === 'select'
          ? MSG_CONFIRM_SELECT_DELETE_UNLIMITED_PERIOD
          : MSG_CONFIRM_ALL_DELETE_UNLIMITED_PERIOD)
      } else {
        return true
      }
    },
    async deleteSelected () {
      const checkedList = this.voucherPackageList.filter((item) => {
        return item.check
      }).map((item) => {
        return item.paymentid
      })
      if (checkedList.length > 0) {
        const { isUnlimitedPeriod, isSalesExpired } = this.purchaseContentsTypeInfo(this.voucherPackageList.filter((content) => content.check))
        if (await this.deleteConfirm(isUnlimitedPeriod, isSalesExpired, 'select')) {
          MyPooqService.deleteMyPurchaseContentItem({ paymentId: checkedList }).then(() => {
            this.voucherPackageList = []
            this.offset = 0
            this.totalCount = 0
            this.setData()
          })
        }
      }
    },
    callApiDeleteAll () {
      MyPooqService.deleteMyPurchasePackageAll().then(() => {
        this.voucherPackageList = []
        this.offset = 0
        this.totalCount = 0
        this.setData()
      })
    },
    async deleteAll () {
      const { isUnlimitedPeriod, isSalesExpired } = this.purchaseContentsTypeInfo(this.voucherPackageList)
      if (!isUnlimitedPeriod && !isSalesExpired) {
        if (await utils.asyncConfirm(`전체삭제를 진행하시겠습니까? ${this.totalCount}건의 내역이 모두 삭제됩니다.`)) {
          this.callApiDeleteAll()
        }
      } else {
        if (await this.deleteConfirm(isUnlimitedPeriod, isSalesExpired, 'all')) {
          this.callApiDeleteAll()
        }
      }
    },
    changeMode () {
      if (this.isDeleteMode) { // off 시킬때
        this.voucherPackageList = this.voucherPackageList.map((voucherPackage) => {
          voucherPackage.check = false
          return voucherPackage
        })
      }
      this.isDeleteMode = !this.isDeleteMode
    },
    loadMore: throttle(function () {
      if (this.endOfList) return
      this.setData()
    }, 120),
    setData () {
      MyPooqService.myPurchaseContentPackage({
        offset: this.offset,
        limit: this.limit,
        dboption: 'master'
      }).then(({ data }) => {
        const resList = get(data, 'list', []).map((item) => {
          item.check = false
          item.toggle = false
          return item
        })
        if (this.totalCount === 0) {
          this.totalCount = Number(get(data, 'pagecount', 0))
        }
        this.endOfList = resList.length === 0
        this.showEmptyList = this.voucherPackageList.length === 0 && resList.length === 0
        this.offset += this.limit
        this.voucherPackageList = this.voucherPackageList.concat(resList)
        EventBus.$emit(SET_EDITOR_VIEW_CLASS, this.voucherPackageList.length !== 0)
      })
    },
    getLazyLoadObj (voucherSingle) {
      return {
        src: resizeThumbnail(voucherSingle.image, { width: 340, height: 480 }),
        error: '/img/common/img_default_thum_1.png',
        loading: '/img/common/img_default_thum_1.png'
      }
    },
    clickToggle (voucherPackage) {
      voucherPackage.toggle = !voucherPackage.toggle
    },
    moveToMoviePlayer (voucherPackage) {
      let url
      if (this.device === 'mobile' && voucherPackage.contenttype === 'movie') {
        url = '/player/movie?movieid=' + voucherPackage.contentid + '&referer=' + this.$route.fullPath
      } else if (this.device === 'mobile' && voucherPackage.contenttype === 'vod') {
        url = '/player/vod?programid=' + voucherPackage.programid + '&contentid=' + voucherPackage.contentid + '&referer=' + this.$route.fullPath
      } else if (this.device !== 'mobile' && voucherPackage.contenttype === 'movie') {
        url = 'captvpooq://player/movie?movieid=' + voucherPackage.contentid
      } else if (this.device !== 'mobile' && voucherPackage.contenttype === 'vod') {
        url = 'captvpooq://player/vod?programid=' + voucherPackage.programid + '&contentid=' + voucherPackage.contentid
      }
      if (this.device === 'mobile') {
        this.$router.push(url)
      } else {
        location.href = url
      }
    }
  }
}
</script>

<style scoped>
  .select-btn {
    display: none !important;
  }
  .package-item-box {
    display: flex;
    padding: 0 10px
  }
  .picture-area {
    flex: none;
  }
  .content-box {
    flex: 1;
  }
</style>
